import Config from '@/tools/config'

// 发票PDF插件
export function pdfTicket(data) {
  return {
    action: '/plugin/pdf/ticket.php',
    data: JSON.stringify({
      ticket: data,
      config: Config.get()
    })
  }
}